/**
 * The function adjusts the Slick carousel based on the window width and a specified breakpoint.
 * @param carousel - The `carousel` parameter is the selector of the elements wrapper
 * @param options - Slick carousel options
 * @param [breakpoint=800] - The `breakpoint` determines at what viewport width the carousel will be destroyed
 */
function handleSlickForMobile(carousel, options, breakpoint = 800) {
  console.log(carousel, options)
  var width = $(window).width();
  if (width >= breakpoint && carousel.hasClass('slick-slider')) {
    carousel.slick('unslick');
  } else if (width < breakpoint && !carousel.hasClass('slick-slider')) {
    carousel.slick(options);
  }
}


$(document).ready(function(){
  $('.pc_carousel').slick({
    infinite: true,
    dots: true, 
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0749/7436/3682/files/Arrow_Right.png?v=1730877152'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0749/7436/3682/files/Arrow_Right.png?v=1730877152'/></button>",
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '200px',
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '40px',
        }
      }
    ]
  });

  const ingredients = $('.ingredients__ingredients');
  const ingredientsOptions = {
    infinite: true,
    dots: true, 
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0749/7436/3682/files/Arrow_Right.png?v=1730877152'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0749/7436/3682/files/Arrow_Right.png?v=1730877152'/></button>",
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true
  };
  
  handleSlickForMobile(ingredients, ingredientsOptions);
  $(window).resize(function () {
    handleSlickForMobile(ingredients, ingredientsOptions);
  });

function initRelatedProductsCarousel() {
  const relatedProducts = $('.related-products.v2 .grid.product-grid');
  if (relatedProducts.length) {
    const relatedProductsOptions = {
      infinite: true,
      dots: true, 
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0749/7436/3682/files/Arrow_Right.png?v=1730877152'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0749/7436/3682/files/Arrow_Right.png?v=1730877152'/></button>",
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true
    };
    handleSlickForMobile(relatedProducts, relatedProductsOptions);
    $(window).resize(function () {
      handleSlickForMobile(relatedProducts, relatedProductsOptions);
    });

    clearInterval(checkExist);
  }
}

const checkIfExists = setInterval(initRelatedProductsCarousel, 500);


  $('.ScrollToProduct').on('click', function (e) {
    e.preventDefault();
    const productSection = $('#product-main').length ? $('#product-main') : $('.shopify-section:has(product-info)');
    const offsetTop = productSection.offset().top - 90;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 600);
  });
  
  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});